import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a570d0c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "onClick"]

interface IProps {
    score: number;
    maxScore?: number;
    editable?: boolean;
  }
  interface IEmits {
    (event: 'update:score', score: number) :void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    score: { default: 0 },
    maxScore: { default: 5 },
    editable: { type: Boolean, default: false }
  },
  emits: ["update:score"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'update:score', score: number) :void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { score: number, maxScore: number, editable: boolean }


  
  

  function handleScore(score: number) {
    if (props.editable) {
      emits('update:score', score);
    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["score", { editable: __props.editable }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.maxScore, (item, index) => {
      return (_openBlock(), _createElementBlock("img", {
        key: index,
        src: index < __props.score ? require('@/assets/icon/icon-star-fill.png') : require('@/assets/icon/icon-star.png'),
        onClick: ($event: any) => (handleScore(index + 1))
      }, null, 8, _hoisted_1))
    }), 128))
  ], 2))
}
}

})